import { Control } from "./Control/Control";
import { Option } from "./Option/Option";
import { NoOptionsMessage, Placeholder, ValueContainer, MultiValue, IndicatorsContainer } from "../CommonComponents";
import { Menu } from "./Menu/Menu";
import { Input } from "./Input/Input";
import { MenuList } from "./MenuList/MenuList";
import { SingleValue } from "./SingleValue/SingleValue";
import { DropdownIndicator } from "./DropdownIndicator/DropdownIndicator";
import { IndicatorSeparator } from "./IndicatorSeparator/IndicatorSeparator";
export var MOBILE_COMPONENTS = {
  Control: Control,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  ValueContainer: ValueContainer,
  Menu: Menu,
  IndicatorsContainer: IndicatorsContainer,
  DropdownIndicator: DropdownIndicator,
  IndicatorSeparator: IndicatorSeparator,
  MenuList: MenuList,
  SingleValue: SingleValue,
  Input: Input,
  MultiValue: MultiValue
};